<template v-slot:actions>
  <div class="actions-container">
    <div class="likeArea" @click="onPostLike(keyPost)">
      <img :src="likeIcon" class="likeIcon" width="28" height="24" />
    </div>
    <div class="shareArea" v-show="allowShare()" @click="onShare()">
      <img
        width="24"
        height="24"
        :src="require('@/assets/img/icons/share.png')"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { isApp } from '@/utils/ReactNative'
import { likeAtScoreStructure } from '@/helper/helper'

export default {
  name: 'Actions',
  props: {
    actionsItemData: Object,
    actionsShare: Object,
    keyPost: String
  },
  data: () => ({}),
  computed: {
    ...mapGetters(['getPostsData', 'getFavsData']),
    isLike () {
      return this.actionsItemData.like
    },
    likeIcon () {
      return !this.actionsItemData.like
        ? require('@/assets/img/icons/dislike.png')
        : require('@/assets/img/icons/like.png')
    }
  },
  methods: {
    ...mapActions({
      likeAction: 'LIKE_TOGGLE',
      favAction: 'ADD_NEW_LIKE',
      shareAction: 'CREATE_SHARE_DOMAIN',
      addChangeToQueue: 'ADD_TO_QUEUE'
    }),
    onPostLike (keyPost) {
      const likeAtScore = likeAtScoreStructure(this.actionsItemData.score)
      this.likeAction({
        keyPost: keyPost,
        score: likeAtScore,
        like: this.actionsItemData.like,
        screenName: this.$router.currentRoute.name
      }).then(() =>
        this.addChangeToQueue({
          key: keyPost,
          currentScreen: 'posts',
          fieldsName: ['like']
        })
      )
    },
    onShare () {
      this.shareAction({ post: this.actionsItemData, share: this.actionsShare })
    },
    allowShare () {
      return isApp
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/publication/actions.vue